<template>
  <div class="animated fadeIn" style="overflow-y:hidden">

    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <!-- <input v-model="rowsPerPageC" type="number"/> -->
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1" :disabled="showLoadingAnimation">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination 
          size="sm" 
          :total-rows="totalRowsC" 
          v-model="currentPage" 
          :per-page="rowsPerPageC" 
          hide-ellipsis
          :limit="paginationButtonsLimit" 
          align="center"
          @change="pageChanged"
          >
      </b-pagination>
      </div>
      <div class="col" align="right">
          <span>Total Rows {{totalRowsC}}</span>  
        </div>
    </div>
    
    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="showLoadingAnimation">Refresh</button>
    <b-table small bordered hover :items="tableRows" :fields="tableHeaders" @row-clicked="tableRowClicked"></b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..." 
      style="margin-left:auto; margin-right:auto; display: block;"
      v-if="showLoadingAnimation">
    <p style="text-align: center"
      v-if="showLoadingError">
    Loading error:
    </p>
    <p style="text-align: center"
      v-if="showNoResult">
    No Result
    </p>

  </div>
</template>

<script>
export default {
  data () {
    return {
      currentPage: this.$store.state.invimpmod.currentPage,
      paginationButtonsLimit: 3
    }
  },
  created: function () {
    // we hook into the created lifecycle to start grabbing data from firestore
    this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' })
  },
  updated: function () {
    // console.log('VUEJS updated hook!')
    let tableElement = document.getElementsByTagName('table')[0]
    let tableOriginalWidth = tableElement.offsetWidth
    // console.log('table width: ' + tableOriginalWidth)

    let tableHeaders = document.getElementsByTagName('th')
    // console.log('tableHeaders: ' + tableHeaders.length)
    let tableBodyCells = document.getElementsByTagName('td')
    // console.log('tableBodyCells: ' + tableBodyCells.length)
    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      let totalColumnWidth = 0
      tableElement.style.width = (tableOriginalWidth * 2) + 'px'
      tableElement.style.maxWidth = (tableOriginalWidth * 2) + 'px'
      // console.log('Post Process: Updated table width to: ' + tableElement.offsetWidth)
      // let totalDiffs = 0
      for (let i = 0; i < tableHeaders.length; i++) {
        let headerWidth = tableHeaders[i].offsetWidth
        let cellWidth = tableBodyCells[i].offsetWidth
        // console.log(i + '-Header width: ' + headerWidth)
        // console.log(i + '-Cell width: ' + cellWidth)
        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px'
          // console.log('updated header width to: ' + tableHeaders[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px'
          // console.log('update cell width to: ' + tableBodyCells[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px'
        tableElement.style.maxWidth = totalColumnWidth + 'px'
        // console.log('Updated table width to: ' + tableElement.offsetWidth)
      }
    }
  },
  methods: {
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('invimpmod/changePageNumber', this.currentPage)
      this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' })
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.invimpmod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('invimpmod/changePageNumber', this.currentPage)
        this.$store.commit('invimpmod/setRowsPerPage', intRows)
        this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' })
      }
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked')
      console.log('item: ' + item)
      // console.log('index: ' + index)
      // let taxInvoice = null
      // for (let i in item) {
      //   // console.log('i: ' + i + ', ' + item[i])
      //   if (i === 'taxInvoice') {
      //     taxInvoice = item[i]
      //   }
      // }
      // // console.log('event: ' + event)

      // document.body.classList.add('footer-hidden')
      // this.$store.commit('usrstomod/updatedSelectedTaxInvoice', taxInvoice)
      // this.$store.dispatch('usrstomod/fetchInvoiceDetails', { taxInvoice: taxInvoice })
    },
    refreshTable: function () {
      this.$store.dispatch('invimpmod/showAllInvoices', { orderBys: 'importDate' })
    }
  },
  computed: {
    tableRows: function () {
      return this.$store.state.invimpmod.all
    },
    tableHeaders: function () {
      return this.$store.getters['invimpmod/getHeaders']
    },
    totalRowsC: function () {
      return this.$store.state.invimpmod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.invimpmod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('invimpmod/setRowsPerPage', newValue)
      }
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.invimpmod.rowsPerPage
    },
    showLoadingAnimation: function () {
      return this.$store.state.invimpmod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.invimpmod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.invimpmod.showNoResult
    }
  },
  name: 'invoiceimports'
}
</script>


// WEBPACK FOOTER //
// src/views/InvoiceImports.vue